export const WIX_SERVICES_APP_ID = 'cc552162-24a4-45e0-9695-230c4931ef40';

//# sourceMappingURL=constants.js.map